import React from 'react';
import PropTypes from 'prop-types';
import { MODAL, TOOLTIP, EMBED, LAYOUT_TRAITS } from 'lib/trait';
import {
  STANDARD,
  HALF_SCREEN,
  FULL_SCREEN,
  COVER_SHEET,
  SLIDEOUT,
  FLOATING,
  ANCHORED,
  ANNOUNCEMENT,
  PROMOTION,
  SURVEY,
  CTA,
  PRESENTATIONS,
  PRESENTATIONS_TYPES,
} from 'lib/presentation';

const StandardIcon = (
  <>
    <rect width="32" height="61" rx="4" fill="#394455" />
    <path stroke="#E7ECF3" d="M12 4h8M12 56h8" />
    <path fill="#B0B6CF" d="M2 8h28v44H2z" />
    <rect x="4" y="18" width="24" height="24" rx="2" fill="#fff" />
    <rect x="10" y="33" width="12" height="4" rx="2" fill="#D7D7FF" />
    <rect x="7" y="28" width="18" height="2" rx="1" fill="#D7D7FF" />
    <rect x="7" y="23" width="18" height="2" rx="1" fill="#D7D7FF" />
  </>
);

const HalfScreenIcon = (
  <>
    <rect width="32" height="61" rx="4" fill="#394455" />
    <path stroke="#E7ECF3" d="M12 4h8M12 56h8" />
    <path fill="#B0B6CF" d="M2 8h28v44H2z" />
    <path fill="#fff" d="M2 30h28v22H2z" />
    <rect x="9" y="44" width="14" height="4" rx="2" fill="#D7D7FF" />
    <rect x="6" y="39" width="20" height="2" rx="1" fill="#D7D7FF" />
    <rect x="6" y="34" width="20" height="2" rx="1" fill="#D7D7FF" />
  </>
);

const FullScreenIcon = (
  <>
    <rect width="32" height="61" rx="4" fill="#394455" />
    <path stroke="#E7ECF3" d="M12 4h8M12 56h8" />
    <path fill="#fff" d="M2 8h28v44H2z" />
    <rect x="9" y="35" width="14" height="4" rx="2" fill="#D7D7FF" />
    <rect x="6" y="28" width="20" height="2" rx="1" fill="#D7D7FF" />
    <rect x="6" y="22" width="20" height="2" rx="1" fill="#D7D7FF" />
  </>
);

const CoverSheetIcon = (
  <>
    <rect width="32" height="61" rx="4" fill="#394455" />
    <path stroke="#E7ECF3" d="M12 4h8M12 56h8" />
    <path fill="#B0B6CF" d="M2 15h28V8H2z" />
    <path d="M2 15a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3v37H2V15Z" fill="#fff" />
    <rect x="9" y="35" width="14" height="4" rx="2" fill="#D7D7FF" />
    <rect x="6" y="28" width="20" height="2" rx="1" fill="#D7D7FF" />
    <rect x="6" y="22" width="20" height="2" rx="1" fill="#D7D7FF" />
  </>
);

const SlideoutIcon = (
  <>
    <rect y=".5" width="32" height="61" rx="4" fill="#394455" />
    <path
      stroke="#E7ECF3"
      strokeWidth="2"
      strokeLinecap="round"
      d="M12 4.5h8M12 56.5h8"
    />
    <path fill="#B0B6CF" d="M2 8.5h28v44H2z" />
    <rect x="4.5" y="32.5" width="17" height="17" rx="2" fill="#fff" />
    <rect
      x="8.75"
      y="43.125"
      width="8.5"
      height="2.833"
      rx="1.417"
      fill="#D7D7FF"
    />
    <rect
      x="6.625"
      y="39.583"
      width="12.75"
      height="1.417"
      rx=".708"
      fill="#D7D7FF"
    />
    <rect
      x="6.625"
      y="36.042"
      width="12.75"
      height="1.417"
      rx=".708"
      fill="#D7D7FF"
    />
  </>
);

const FloatingIcon = (
  <>
    <rect y=".5" width="32" height="61" rx="4" fill="#394455" />
    <path stroke="#E7ECF3" d="M12 4.5h8M12 56.5h8" />
    <path fill="#B0B6CF" d="M2 8.5h28v44H2z" />
    <rect x="6" y="15.5" width="20" height="20" rx="2" fill="#fff" />
    <rect x="11" y="28.5" width="10" height="4" rx="2" fill="#D7D7FF" />
    <rect x="9" y="23.5" width="14" height="2" rx="1" fill="#D7D7FF" />
    <rect x="9" y="18.5" width="14" height="2" rx="1" fill="#D7D7FF" />
    <path d="m16 38.5-1.732-3h3.464L16 38.5ZM15.5 41.5h1v4h-1z" fill="#fff" />
    <path fill="#fff" d="M18 43v1h-4v-1z" />
  </>
);

const AnchoredIcon = (
  <>
    <rect width="32" height="61" rx="4" fill="#394455" />
    <path stroke="#E7ECF3" d="M12 4h8m-8 52h8" />
    <path fill="#B0B6CF" d="M2 8h28v44H2z" />
    <rect x="6" y="15" width="20" height="20" rx="2" fill="#fff" />
    <path
      d="M17.56 23.055a.777.777 0 1 1 0 1.556h-.779v5.058h1.167a2.335 2.335 0 0 0 2.335-2.335v-.148l-.192.15c-.207.249-.577.249-.805 0-.226-.206-.226-.575 0-.804l1.361-1.362c.229-.226.599-.226.805 0l1.362 1.362c.248.229.248.598 0 .805-.207.248-.576.248-.805 0l-.17-.15v.147a3.89 3.89 0 0 1-3.89 3.891h-3.891a3.89 3.89 0 0 1-3.89-3.89v-.149l-.172.15a.55.55 0 0 1-.825 0c-.228-.206-.228-.575 0-.804l1.362-1.362a.587.587 0 0 1 .825 0l1.34 1.362c.248.229.248.598 0 .805-.206.248-.576.248-.804 0l-.17-.15v.147a2.321 2.321 0 0 0 2.334 2.335h1.167V24.61h-.778a.777.777 0 1 1 0-1.556h.265a2.33 2.33 0 0 1-1.043-1.945 2.32 2.32 0 0 1 2.334-2.335 2.335 2.335 0 0 1 2.334 2.335c0 .812-.435 1.527-1.043 1.945h.265Zm-1.557-1.167a.777.777 0 1 0 .002-1.555.777.777 0 0 0-.002 1.555Z"
      fill="#B0B6CF"
    />
    <path d="m16 38-1.732-3h3.464L16 38Z" fill="#fff" />
  </>
);

const AnnouncementIcon = (
  <>
    <g clipPath="url(#a)">
      <path
        fill="#5C5CFF"
        d="M48.999.194h-42c-3.856 0-7 3.144-7 6.901v31.402c0 3.855 3.144 6.901 7 6.901h10.5v9.09c0 1.076 1.206 1.7 2.091 1.06L33.251 45.3h15.75c3.856 0 7-3.144 7-6.901V7.095C56 3.338 52.947.194 49 .194Zm3.598 38.5a3.51 3.51 0 0 1-3.5 3.5h-15.76a3.5 3.5 0 0 0-2.102.7l-10.138 7.612v-6.562a1.75 1.75 0 0 0-1.75-1.75H7.097a3.51 3.51 0 0 1-3.5-3.5v-31.5a3.51 3.51 0 0 1 3.5-3.5h42a3.51 3.51 0 0 1 3.5 3.5v31.5ZM28 28.095c1.06 0 1.848-.689 1.848-1.651v-15.75a1.749 1.749 0 1 0-3.5 0v15.75c0 .962.777 1.651 1.652 1.651Zm.098 2.724a2.625 2.625 0 1 0 2.625 2.625 2.619 2.619 0 0 0-2.625-2.625Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h56v56H0z" />
      </clipPath>
    </defs>
  </>
);

const PromotionIcon = (
  <>
    <g clipPath="url(#a)">
      <path
        fill="#5C5CFF"
        d="m29.848 17.664-.087.011c.689.087 2.494.438 3.16.613a1.764 1.764 0 0 1 1.248 2.143 1.754 1.754 0 0 1-2.144 1.236 42.398 42.398 0 0 0-2.712-.536c-1.586-.251-2.943-.054-3.861.361-.92.416-1.302.974-1.39 1.488-.087.525-.01.83.077 1.017.099.208.284.437.667.7.853.58 2.144.973 3.817 1.487l.055.011c1.411.449 3.38 1.017 4.758 1.925.744.635 1.41 1.346 1.827 2.308.426.963.514 2.034.317 3.183-.35 2.056-1.707 3.456-3.446 4.2-.7.306-1.476.503-2.286.602v1.257c0 .963-.787 1.75-1.75 1.75-.962 0-1.75-.787-1.75-1.75v-1.334l-.01-.011h-.011c-1.116-.175-2.92-.798-4.047-1.181-.22-.077-.416-.142-.57-.197-.918-.295-1.41-1.39-1.104-2.21a1.742 1.742 0 0 1 2.21-1.104c.23.076.382.065.743.251 1.149.394 2.538.864 3.325.985 1.641.262 2.975.11 3.872-.274.842-.36 1.258-.886 1.378-1.575.099-.601.022-.962-.076-1.203-.11-.24-.306-.492-.678-.765-.832-.602-2.1-1.018-3.763-1.62l-.24.023c-1.455-.438-3.216-.963-4.529-1.86-.743-.503-1.432-1.17-1.87-2.1-.448-.94-.558-1.99-.36-3.106.327-1.947 1.716-3.325 3.39-4.08.71-.328 1.498-.547 2.34-.678V16.33c0-.963.788-1.75 1.75-1.75.963 0 1.75.787 1.75 1.75v1.334Zm7.679-12.673a11.58 11.58 0 0 1 10.27 3.21c2.8 2.791 3.86 6.663 3.216 10.272C54.02 20.464 56 24.052 56 27.902c0 4.046-1.98 7.535-4.987 9.625.645 3.609-.416 7.48-3.216 10.27-2.79 2.8-6.661 3.86-10.27 3.216A11.586 11.586 0 0 1 28 56c-3.948 0-7.536-1.98-9.527-4.987-3.609.645-7.48-.416-10.272-3.216a11.58 11.58 0 0 1-3.21-10.27C1.978 35.437 0 31.948 0 27.902c0-3.85 1.978-7.438 4.99-9.429A11.586 11.586 0 0 1 8.2 8.201a11.586 11.586 0 0 1 10.273-3.21C20.464 1.978 24.052 0 27.902 0c4.046 0 7.535 1.978 9.625 4.99ZM20.169 9.087l-1.39-.425a8.082 8.082 0 0 0-8.103 2.014 8.082 8.082 0 0 0-2.014 8.104l.425 1.389-1.278.678C5.242 22.203 3.5 24.905 3.5 27.902c0 3.193 1.742 5.796 4.31 7.251l1.277.678-.425 1.39a8.09 8.09 0 0 0 2.014 8.104 8.09 8.09 0 0 0 8.104 2.012l1.389-.426.678 1.28A8.08 8.08 0 0 0 28 52.5c3.095 0 5.698-1.74 7.153-4.31l.678-1.28 1.39.428a8.1 8.1 0 0 0 8.104-2.013 8.1 8.1 0 0 0 2.012-8.105l-.426-1.389 1.28-.678c2.57-1.455 4.309-4.058 4.309-7.251 0-2.997-1.74-5.699-4.31-7.055l-1.28-.678.428-1.39a8.093 8.093 0 0 0-2.013-8.104 8.084 8.084 0 0 0-8.105-2.013l-1.389.425-.678-1.278C33.698 5.242 31.095 3.402 28 3.402c-3.095 0-5.797 1.84-7.153 4.407l-.678 1.278Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h56v56H0z" />
      </clipPath>
    </defs>
  </>
);

const SurveyIcon = (
  <path
    d="M45.309 2.319a5.636 5.636 0 0 1 7.993-.025l1.047 1.05c2.201 2.2 2.201 5.77 0 7.97L37.404 28.26a5.62 5.62 0 0 1-2.826 1.532l-7.527 1.585c-.545.097-.95-.053-1.285-.388-.334-.413-.484-.818-.387-1.285l1.584-7.535a5.657 5.657 0 0 1 1.506-2.808l16.84-17.042Zm5.995 1.967a2.818 2.818 0 0 0-3.997.013l-2.403 2.356L50 11.675l2.359-2.359a2.82 2.82 0 0 0 0-3.98l-1.056-1.05ZM29.719 22.741l-1.136 5.431 5.414-1.135a2.838 2.838 0 0 0 1.417-.766l12.597-12.606-5.009-5.005L30.476 21.34a2.876 2.876 0 0 0-.757 1.4ZM26.76 11.552c.775 0 1.409.634 1.409 1.409 0 .774-.634 1.408-1.409 1.408H5.634a2.816 2.816 0 0 0-2.817 2.817v22.536a2.816 2.816 0 0 0 2.817 2.817H45.07a2.814 2.814 0 0 0 2.817-2.817V24.229c0-.775.634-1.409 1.409-1.409.774 0 1.408.634 1.408 1.409v15.493a5.64 5.64 0 0 1-5.634 5.634H5.634A5.636 5.636 0 0 1 0 39.722V17.186a5.636 5.636 0 0 1 5.634-5.634H26.76ZM9.155 28.454c0-1.17.942-2.113 2.113-2.113 1.17 0 2.112.942 2.112 2.113 0 1.17-.941 2.113-2.112 2.113a2.108 2.108 0 0 1-2.113-2.113Zm12.676 0c0 1.17-.942 2.113-2.112 2.113a2.108 2.108 0 0 1-2.113-2.113c0-1.17.942-2.113 2.113-2.113 1.17 0 2.112.942 2.112 2.113Z"
    fill="#5C5CFF"
  />
);

const CtaIcon = (
  <path
    d="M14.405 9.999c1.847 0 3.002-2 2.078-3.6a2.401 2.401 0 0 0-2.078-1.2c-1.848 0-3.002 2-2.079 3.6a2.402 2.402 0 0 0 2.079 1.2Zm0-7.999c4.31 0 7.004 4.666 4.849 8.398a5.598 5.598 0 0 1-4.849 2.8c-4.311 0-7.005-4.666-4.85-8.399A5.601 5.601 0 0 1 14.405 2Zm-3.2 16.397v15.597h6.399V18.397c-.6-.26-1.25-.4-1.929-.4h-2.54c-.68 0-1.33.14-1.93.4Zm0 18.797v14.397c0 .88-.72 1.6-1.6 1.6-.88 0-1.6-.72-1.6-1.6V22.206l-4.989 9.339c-.42.78-1.39 1.07-2.17.66-.78-.41-1.07-1.39-.66-2.17l5.89-11.008a8 8 0 0 1 7.059-4.229h2.54a8.014 8.014 0 0 1 7.059 4.229l4.869 9.108c-.75.98-1.4 2.05-1.93 3.18l-4.859-9.099v29.375c0 .88-.72 1.6-1.6 1.6-.88 0-1.6-.72-1.6-1.6V37.194h-6.409Zm41.596 1.599c0-8.62-9.333-14.007-16.799-9.697a11.196 11.196 0 0 0-5.599 9.697c0 8.621 9.332 14.008 16.798 9.698 3.465-2 5.6-5.697 5.6-9.698Zm-25.598 0c0-11.083 11.999-18.01 21.598-12.468A14.397 14.397 0 0 1 56 38.793c0 11.084-11.998 18.011-21.597 12.469a14.398 14.398 0 0 1-7.2-12.469Zm14.399 3.2c1.847 0 3.002 1.999 2.078 3.599a2.4 2.4 0 0 1-2.078 1.2c-1.847 0-3.002-2-2.078-3.599a2.398 2.398 0 0 1 2.078-1.2Zm0-11.198c.88 0 1.6.72 1.6 1.6v6.398c0 .88-.72 1.6-1.6 1.6-.88 0-1.6-.72-1.6-1.6v-6.398c0-.88.72-1.6 1.6-1.6Z"
    fill="#5C5CFF"
  />
);

const ICONS = {
  [MODAL]: {
    [STANDARD]: StandardIcon,
    [HALF_SCREEN]: HalfScreenIcon,
    [FULL_SCREEN]: FullScreenIcon,
    [COVER_SHEET]: CoverSheetIcon,
    [SLIDEOUT]: SlideoutIcon,
  },
  [TOOLTIP]: {
    [FLOATING]: FloatingIcon,
    [ANCHORED]: AnchoredIcon,
  },
  [EMBED]: {
    [ANNOUNCEMENT]: AnnouncementIcon,
    [PROMOTION]: PromotionIcon,
    [SURVEY]: SurveyIcon,
    [CTA]: CtaIcon,
  },
};

const PresentationIcon = ({ layoutTrait, presentation }) => {
  const embedSizes = {
    viewbox: '0 0 56 56',
    width: '56',
    height: '56',
  };

  const defaultSizes = {
    viewbox: '0 0 32 61',
    width: '32',
    height: '61',
  };

  const { viewBox, width, height } =
    layoutTrait === EMBED ? embedSizes : defaultSizes;

  return (
    <svg
      aria-label={PRESENTATIONS[layoutTrait][presentation]}
      role="img"
      fill="none"
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      {ICONS[layoutTrait][presentation]}
    </svg>
  );
};

export default PresentationIcon;

PresentationIcon.propTypes = {
  layoutTrait: PropTypes.oneOf(LAYOUT_TRAITS),
  presentation: PropTypes.oneOf(PRESENTATIONS_TYPES),
};
